<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="供应商名称">
            <a-input v-decorator="['companyName']" placeholder="请输入供应商名称"></a-input>
          </a-form-item>
          <!-- <a-form-item label="类型">
            <a-select
              class="form-control sm"
              v-decorator="['companyType']"
              placeholder="请选择"
              allowClear
              :options="typesMap.companyType"
            ></a-select> 
          </a-form-item> -->
          <a-form-item label="业务类型">
            <a-select
              class="form-control sm"
              v-decorator="['businessType']"
              placeholder="请选择"
              allowClear
              :options="typesMap.businessType"
            ></a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">供应商列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="doExport">
          <app-icon type="icon-daochu"></app-icon>
          导出EXCEL
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="
            (record, index) => {
              return index
            }
          "
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import { companyType } from '@/vars'
import fileDownload from 'js-file-download'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '90px',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '供应商名称',
        align: 'center',
        dataIndex: 'merchantName',
      },
      {
        title: '业务类型',
        width: '100px',
        align: 'center',
        dataIndex: 'businessType',
        customRender: (text, row) => {
          return <div>{this.translateType$t(text, 'businessType')}</div>
        },
      },
      {
        title: '联系人',
        width: '150px',
        align: 'center',
        dataIndex: 'contactPerson',
      },
      {
        title: '联系电话',
        width: '150px',
        align: 'center',
        dataIndex: 'contactPhoneNumber',
      },
      {
        title: '合同截止',
        width: '120px',
        align: 'center',

        dataIndex: 'contractEndDate',
      },
      {
        title: '合同状态',
        width: '100px',
        align: 'center',

        dataIndex: 'contractStatus',
        customRender: (text) => {
          return <div>{this.translateType$t(text, 'contractStatus')}</div>
        },
      },
      {
        title: '操作',
        width: '200px',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500">
              {row.isDisable === 0 && (
                <a-button
                  type="link"
                  size="small"
                  onClick={() => {
                    this.checkRow(row, 'VIEW')
                  }}
                >
                  查看
                </a-button>
              )}
              {row.isDisable === 1 && (
                <a-button
                  type="link"
                  size="small"
                  onClick={() => {
                    this.checkRow(row, 'EDIT')
                  }}
                >
                  编辑
                </a-button>
              )}
              <a-button
                type="link"
                size="small"
                onClick={() => {
                  this.changeDisable(row)
                }}
              >
                {row.isDisable ? '启用' : '禁用'}
              </a-button>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        companyType,
        contractStatus: [
          { value: 1, label: '未续约' },
          { value: 2, label: '存续' },
          { value: 3, label: '过期' },
        ],
        businessType: [
          { value: 1, label: '签证业务' },
          { value: 2, label: '公证业务' },
          { value: 3, label: '认证业务' },
        ],
      }
    },
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const { businessType, companyName, companyType } = this.form.getFieldsValue()
        const res = await this.$axios.get('/company/admin/company/queryList', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            businessType,
            companyName,
            companyType,
          },
        })
        // res.data.content.forEach(element => {
        //   element['businessType'] = Math.floor(Math.random()*3) + 1
        // })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    async changeDisable(row) {
      const title = row.isDisable ? '确定启用帐号？' : '确定冻结帐号？'
      const content = (
        <div class="h-28 flex items-center justify-center text-red-400">
          {row.isDisable
            ? '你确认要启用本帐号吗？开启后将开放系统所有功能，针对供应商的所有到期分帐和付款将自动开始处理。'
            : '你确认要冻结本帐号吗？冻结后该帐号无法再登录，无法再使用本系统所有功能，所有付款和分帐也将暂停。'}
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.post('/company/admin/company/isDisable', {
        companyId: row.companyId,
        isDisable: row.isDisable ? 0 : 1,
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    checkRow(row, type) {
      switch (row.businessType) {
        case 1:
          this.$router.push({
            path: '/m/scopeMain/merchantList/merchantListDetail',
            query: {
              companyId: row.companyId,
              handleType: type,
            },
          })
          break
        case 2:
          this.$router.push({
            // path: '/m/scopeMain/merchantList/merchantListDetail',
            path: '/m/scopeMain/merchantList/notarizationDetail',
            query: {
              companyId: row.companyId,
              handleType: type,
            },
          })
          break
        case 3:
          this.$router.push({
            // path: '/m/scopeMain/merchantList/merchantListDetail',
            path: '/m/scopeMain/merchantList/authenticationDetail',
            query: {
              companyId: row.companyId,
              handleType: type,
            },
          })
          break

        case null:
          this.$router.push({
            path: '/m/scopeMain/merchantList/merchantListDetail',
            query: {
              companyId: row.companyId,
              handleType: type,
            },
          })
      }
    },
    async doExport() {
      const res = await this.$axios.get(
        `/company/admin/company/download`,
        {
          params: {
            ...this.form.getFieldsValue(),
          },
        },
        {
          responseType: 'blob',
          interceptors: {
            response: false,
          },
        }
      )
      fileDownload(res.data, '企业列表.xls')
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less"></style>
